import Vue from 'vue'
import Router from 'vue-router'
import baseRoutes from './routes'
import knockoutGameRoutes from "./routes/knockoutGameRoutes";
import store from '@/store'
import middlewarePipeline from "./middlewarePipeline";
import gamePage from "@/router/middleware/gamePage";
import showNavigation from "@/router/middleware/showNavigation";
import loadState from "@/router/middleware/loadState";
import channelRoutes from "./routes/channelRoutes";
import chatRoutes from "./routes/chatRoutes";
import tournamentRoutes from "./routes/tournamentRoutes";

Vue.use(Router)

const routes = baseRoutes.concat(knockoutGameRoutes, channelRoutes, chatRoutes, tournamentRoutes);

const router = createRouter({base: '/'})

let globalMiddlewareStack = [
    loadState,
    gamePage,
    showNavigation,
]

export default router

/**
 * The router factory
 */
function createRouter({base}) {
    const router = new Router({
        scrollBehavior,
        base,
        mode: 'history',
        linkActiveClass: 'active',
        routes,
    })

    router.beforeEach(beforeEach)

    return router
}

/**
 * Global router guard.
 *
 * @param {Route} to
 * @param {Route} from
 * @param {Function} next
 */
async function beforeEach(to, from, next) {

    const middleware = globalMiddlewareStack.concat(get(to, 'meta.middleware', []))

    if (! middleware) {
        return next()
    }

    const context = {
        to,
        from,
        next,
        store
    }

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
}

/**
 * Scroll Behavior
 *
 * @link https://router.vuejs.org/en/advanced/scroll-behavior.html
 *
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }

    if (to.hash) {
        return {selector: to.hash}
    }

    const [component] = router.getMatchedComponents({...to}).slice(-1)

    if (component && component.scrollToTop === false) {
        return {}
    }

    return {x: 0, y: 0}
}
